import { render, staticRenderFns } from "./EditServiceProviderWorkerProfileForm.vue?vue&type=template&id=4a5fb6f0"
import script from "./EditServiceProviderWorkerProfileForm.vue?vue&type=script&lang=js"
export * from "./EditServiceProviderWorkerProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports